export function getDeviceCompatibility(userAgent: string): {
  isCompatible: boolean,
  os?: 'iOS' | 'Android' | 'Other',
  version?: string
} {
  const isIOS = /iPad|iPhone|iPod/.test(userAgent)
  const isAndroid = /Android/.test(userAgent)

  if (isIOS) {
    const match = userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/)
    if (match) {
      const major = parseInt(match[1], 10)
      return {isCompatible: major >= 11, os: 'iOS', version: `${match[1]}.${match[2]}`}
    }
    // If we can't determine version but it is iOS, we might want to be cautious or permissive.
    // Usually iOS UAs have the version.
    return {isCompatible: false, os: 'iOS'}
  }

  if (isAndroid) {
    const match = userAgent.match(/Android (\d+)(?:\.(\d+))?/)
    if (match) {
      const major = parseInt(match[1], 10)
      const minor = parseInt(match[2] ?? '0', 10)
      const isCompatible = major > 5 || (major === 5 && minor >= 1)
      return {isCompatible, os: 'Android', version: `${major}.${minor}`}
    }
    return {isCompatible: false, os: 'Android'}
  }

  return {isCompatible: false, os: 'Other'}
}
